<template>
  <div class="resume-create-picker-container onboarding-block-container">
    <div class="resume-create-title">{{ title }}</div>
    <div class="flex items-center list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="flex-1 flex flex-col items-center justify-center resume-list-item"
        :class="item.mode"
        @click="clickItem(item.value)"
      >
        <img class="item-icon" :src="item.image" alt="" />
        <div>{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>
<script>
const EXPORT_LIST = [
  {
    image: 'https://logo.wondercv.com/banners/p703s1FXDQ0yjwk.png',
    label: '导入本地简历',
    value: 'local',
  },
  {
    image: 'https://logo.wondercv.com/banners/FHhEgXuGqSOnx4L.png',
    label: '基于已有简历创建',
    value: 'based',
  },
];

const CREATE_LIST = [
  {
    image: 'https://logo.wondercv.com/banners/9KzXWVwMv2ykvhD.png',
    label: 'AI 智能创建简历',
    value: 'ai',
    mode: 'recommend',
  },
  {
    image: 'https://logo.wondercv.com/banners/6kQTWJmcyzv1Ey8.png',
    label: '我要自己写',
    value: 'template',
  },
];
export default {
  name: 'ResumeCreatePicker',
  props: {
    resume: String,
  },
  computed: {
    title() {
      return this.resume === 'yes' ? '请选择简历导入方式' : '请选择简历创建方式';
    },
    editableResume() {
      return this.$store.state.cv.cvs?.some((item) => item.can_editable);
    },
    list() {
      const exports = this.editableResume
        ? EXPORT_LIST
        : EXPORT_LIST.filter((item) => item.value === 'local');
      return this.resume === 'yes' ? exports : CREATE_LIST;
    },
  },
  methods: {
    clickItem(value) {
      this.$emit('clickItem', value);
    },
  },
};
</script>
<style lang="scss" scoped>
.resume-create-picker-container {
  margin-top: 16px;
  margin-left: 64px;
  width: 580px;
  .resume-create-title {
    color: #fff;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .list {
    gap: 20px;
    .resume-list-item {
      position: relative;
      height: 162px;
      color: #fff;
      border-radius: 8px;
      background: #3d4048;
      cursor: pointer;
      .item-icon {
        width: 32px;
        height: 32px;
        margin-bottom: 20px;
      }
      &.recommend::after {
        content: '推荐';
        position: absolute;
        top: 0;
        right: 0;
        display: inline-block;
        border-radius: 0px 8px 0px 10px;
        background: #f64;
        color: #fff;
        font-size: 12px;
        width: 44px;
        height: 21px;
        text-align: center;
        line-height: 21px;
        font-weight: 500;
      }
    }
  }
}
</style>
